import { createAction } from '@ngrx/store';

const TAG = '[ExternalLink/View]';

export const loadExternalLinks = createAction(`${TAG} Load playlists`);
